export default __webpack_public_path__ + "static/media/cart.d9a012d6.svg";